export default "__VITE_ASSET__8666813f__"